import getColumnProperty from "@/funcs/getColumnProperty";
import getViewName from "@/funcs/getViewName";
import getDate from "@/funcs/getDate";
import getDateRange from "@/funcs/getDateRange";
import formatDateRange from "@/funcs/formatDateRange";
import * as crypto from "@/funcs/crypto";
import * as localStorage from "@/funcs/localStorage";
import * as defaultModel from "@/funcs/defaultModel";
import getExcel from "@/funcs/getExcel";
import getPdf from "@/funcs/getPdf";
import getTXT from "@/funcs/getTXT";
import postExcel from "@/funcs/postExcel";
import postFile from "@/funcs/postFile";
import printPdf from "@/funcs/printPdf";
import uuid from "@/funcs/uuid";
import foods from "@/funcs/foods";
import {
  calculateTrade,
  calculateTradeDet,
  rebuildTradeDetOnTaxTypeChange,
  rebuildTradeDetOnTaxAdditionChange,
  roundTo,
} from "@/funcs/calculateTax";
import * as math from "@/funcs/math";
import copy from "@/funcs/copy";
import message from "@/funcs/message";
import isLeapYear from "@/funcs/isLeapYear";
import isCustomizationBusiness from "@/funcs/isCustomizationBusiness";
import canUseRequisitionWorkflow from "@/funcs/canUseRequisitionWorkflow";
import getMemberCarrierInvoiceParams from "@/funcs/getMemberCarrierInvoiceParams";
import * as password from "@/funcs/password";

export default {
  getColumnProperty,
  getViewName,
  getDate,
  getDateRange,
  formatDateRange,
  crypto,
  localStorage,
  defaultModel,
  getExcel,
  getPdf,
  getTXT,
  postExcel,
  postFile,
  printPdf,
  uuid,
  foods,
  calculateTrade,
  calculateTradeDet,
  rebuildTradeDetOnTaxTypeChange,
  rebuildTradeDetOnTaxAdditionChange,
  roundTo,
  math,
  copy,
  message,
  isLeapYear,
  isCustomizationBusiness,
  canUseRequisitionWorkflow,
  getMemberCarrierInvoiceParams,
  password,
};
